(function ($) {
  'use strict';

  Drupal.behaviors.fastFacts = {
    attach: function () {
      // Reinitialize slider on window size change.
      $(window).resize(function () {
        $('.fast-facts__facts-container').slick('resize');
      });

      $('.fast-facts__facts-container').slick({
        mobileFirst: true,
        slidesToShow: 1,
        prevArrow: '.fast-facts__slider-prev',
        nextArrow: '.fast-facts__slider-next',
        dots: true,
        responsive: [
          {
            breakpoint: 639,
            settings: 'unslick'
          },
        ]
      });

      $('.fast-facts__fact').attr('tabindex', '-1');
    }
  };
}(jQuery));
